module.exports = __webpack_public_path__ + "img/bg6.36fdee1a.png";